var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFasterTimeHire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.202,
    height: 38.822,
    viewBox: "0 0 34.202 38.822",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Time",
    transform: "translate(-2.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M26.84,28.521a12.121,12.121,0,1,0-8.715,3.721,12.121,12.121,0,0,0,8.715-3.721Zm-8.715-18.1a9.7,9.7,0,0,1,8,15.163,9.563,9.563,0,0,0-4.364-3.515,4.848,4.848,0,1,0-7.273,0,9.563,9.563,0,0,0-4.351,3.515,9.7,9.7,0,0,1,7.988-15.163ZM15.7,18.909a2.424,2.424,0,1,1,2.424,2.424A2.424,2.424,0,0,1,15.7,18.909Zm-3.9,8.545a7.273,7.273,0,0,1,12.654,0A9.7,9.7,0,0,1,11.8,27.454Z",
    transform: "translate(0.842 1.696)",
    fill: "#694be7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M20.179,4.909V2.424H22.6A1.212,1.212,0,1,0,22.6,0H15.331a1.212,1.212,0,0,0,0,2.424h2.424V4.909a16.884,16.884,0,0,0-8.485,3.03L7.828,6.533,9.537,4.848A1.213,1.213,0,0,0,7.828,3.127c-10.472,10.448-.982.994-5.139,5.127A1.217,1.217,0,0,0,4.422,9.963L6.107,8.254,7.319,9.466A16.969,16.969,0,0,0,9.9,36.132a1.214,1.214,0,0,0,1.285-2.061,14.545,14.545,0,1,1,4.4,1.854,1.214,1.214,0,0,0-.558,2.364A16.969,16.969,0,1,0,20.179,4.909Z",
    transform: "translate(0)",
    fill: "#694be7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFasterTimeHire);
export default __webpack_public_path__ + "static/media/fasterTimeHire.b7c79f772d8fd5070c36513569d83682.svg";
export { ForwardRef as ReactComponent };